import React from 'react'

import css from './WelcomeONas.module.css'

const WelcomeONas = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>O NAS</p>
			</div>
		</section>
	)
}

export default WelcomeONas
